import { z } from 'zod'
import { FinancialCacheSchema } from '@shared/contracts/financial-cache'
import { CurrencySchema } from './enums'
import { MonetaryValueSchema as Money } from '../lib/money/money'

export const AnalyticsRateSchema = z.object({
  count: z.number(),
  base: z.number(),
  pct: z.number().nullable(),
})
export const AnalyticsWindowSchema = z.object({
  from: z.string(),
  to: z.string(),
  asOf: z.string(),
  timeZone: z.string(),
})
const Source = z.object({ gross: Money, net: Money, charges: z.number() })
const Adjustment = z.object({ amount: Money, count: z.number() })
export const SalesAnalyticsSchema = z.object({
  cache: FinancialCacheSchema.optional(),
  window: AnalyticsWindowSchema,
  currencies: z.array(CurrencySchema),
  primaryCurrency: CurrencySchema,
  byCurrency: z.record(
    z.string(),
    z.object({
      sources: z.object({ oneTime: Source, subscriptionInitial: Source, renewals: Source }),
      total: Source,
      newCustomers: z.number(),
      newSubscriptions: z.number(),
      estimatedAllocation: z.boolean(),
      result: Money,
      adjustments: z.object({
        fxLosses: Adjustment.optional(),
        refunds: Adjustment,
        preventedRefunds: Adjustment,
        chargebacks: Adjustment,
        feesPaid: Adjustment,
        feesPending: Adjustment,
        credits: Adjustment,
        total: Money,
      }),
      quality: z.object({ refunds: AnalyticsRateSchema, chargebacks: AnalyticsRateSchema }),
    }),
  ),
})
export type SalesAnalytics = z.infer<typeof SalesAnalyticsSchema>
